export const handleUnauthorized = () => {
  localStorage.removeItem('google_token');
  
  // Dispatch a custom event that AuthContext can listen to
  window.dispatchEvent(new CustomEvent('auth:expired'));
  
  // Navigate to home page
  window.location.href = '/';
};